export default function animateTypingText() {
    const headingList = document.querySelectorAll('.animated_typing_text');
    if (headingList.length === 0)
        return;
    [...headingList].forEach((heading) => {
        if (!heading)
            return;
        const dataItems = heading.getAttribute('data-items');
        if (!dataItems) {
            return;
        }
        const dataText = JSON.parse(dataItems);
        function typeWriter(text, i, fnCallback) {
            if (i < text.length) {
                heading.innerHTML = `${text.substring(0, i + 1)}<span aria-hidden="true"></span>`;
                setTimeout(() => typeWriter(text, i + 1, fnCallback), 100);
            }
            else if (fnCallback) {
                setTimeout(fnCallback, 3000);
            }
        }
        function StartTextAnimation(i) {
            if (i >= dataText.length) {
                setTimeout(() => StartTextAnimation(0), 2000);
                return;
            }
            typeWriter(dataText[i], 0, () => StartTextAnimation(i + 1));
        }
        StartTextAnimation(0);
    });
}
export function zoomImage() {
    const image = document.querySelector('.js--zoom-image');
    let isInView = false;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const visibility = entry.intersectionRatio;
            if (visibility > 0.7 && !isInView) {
                image.classList.add('in-view');
                isInView = true;
            }
            else if (visibility < 0.3 && isInView) {
                image.classList.remove('in-view');
                isInView = false;
            }
            if (window.scrollY === 0) {
                image.classList.remove('in-view');
                isInView = false;
            }
        });
    }, { threshold: [0.3, 0.7] });
    if (image) {
        observer.observe(image);
    }
}
